import Button from '../common/Button';
import DemoLink from './DemoLink';
import ExternalLink from './ExternalLink';
import PostImg from './PostImg';
import CodeBlock from './CodeBlock';
import H3Heading from './H3Heading';
import CoffeeBanner from './CoffeeBanner';

// Shortcodes are components that are available within the MDX post files without needing to
// import them. They're passed in via the MDXProvider component
export default {
  Button,
  DemoLink,
  ExternalLink,
  PostImg,
  CoffeeBanner,
  pre: (props) => <CodeBlock {...props} />,
  wrapper: ({ children }) => <>{children}</>,
  h3: H3Heading,
};
